import { render, staticRenderFns } from "./SurveyTabularCell.vue?vue&type=template&id=a84f00a4"
import script from "./SurveyTabularCell.vue?vue&type=script&lang=js"
export * from "./SurveyTabularCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports